import { createAction } from 'redux-actions'
import {
  UPDATE_RECEIPT,
  UPDATE_RECEIPT_FAILED,
  UPDATE_RECEIPT_SUCCEEDED,
} from 'Redux/Types/ReceiptTypes'

export const updateReceipt = createAction(UPDATE_RECEIPT)
export const updateReceiptFailed = createAction(UPDATE_RECEIPT_FAILED)
export const updateReceiptSucceeded = createAction(UPDATE_RECEIPT_SUCCEEDED)
